const buildVariant = (fontFamily, fontSize, fontWeight, letterSpacing, lineHeight) => ({
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    lineHeight,
});
export const typography = {
    "Visual.EN.Display01": buildVariant("Nunito", 64, 700, -2, "135%"),
    "Visual.EN.Display02": buildVariant("Nunito", 52, 700, -2, "135%"),
    "Visual.EN.Display03": buildVariant("Nunito", 48, 700, -1, "135%"),
    "Visual.EN.Header01": buildVariant("Nunito", 40, 800, -1, "135%"),
    "Visual.EN.Header02": buildVariant("Nunito", 32, 800, -0.6, "135%"),
    "Visual.EN.Header03": buildVariant("Nunito", 24, 800, -0.4, "135%"),
    "Visual.EN.Title01": buildVariant("Nunito", 20, 700, -0.4, "135%"),
    "Visual.EN.Title02": buildVariant("Nunito", 18, 700, -0.4, "135%"),
    "Visual.EN.Title03": buildVariant("Nunito", 16, 800, -0.4, "135%"),
    "Visual.EN.Title04": buildVariant("Nunito", 14, 800, -0.2, "140%"),
    "Visual.EN.Subtitle01": buildVariant("Nunito", 18, 700, -0.4, "135%"),
    "Visual.EN.Subtitle02": buildVariant("Nunito", 16, 700, -0.4, "135%"),
    "Visual.EN.Subtitle03": buildVariant("Nunito", 14, 700, -0.2, "140%"),
    "Visual.EN.Subtitle04": buildVariant("Nunito", 13, 700, -0.2, "135%"),
    "Visual.EN.Body01": buildVariant("Nunito", 18, 500, -0.4, "135%"),
    "Visual.EN.Body02": buildVariant("Nunito", 16, 500, -0.4, "135%"),
    "Visual.EN.Body03": buildVariant("Nunito", 14, 500, -0.2, "140%"),
    "Visual.EN.Body04": buildVariant("Nunito", 13, 500, -0.2, "135%"),
    "Visual.EN.Caption01": buildVariant("Nunito", 12, 800, 0, "135%"),
    "Visual.EN.Caption02": buildVariant("Nunito", 12, 500, 0, "135%"),
    "Visual.EN.Caption03": buildVariant("Nunito", 10, 800, 0, "135%"),
    "Visual.EN.Caption04": buildVariant("Nunito", 10, 500, 0, "135%"),
    "Content.Display01": buildVariant("Roboto, Noto Sans KR, sans-serif", 64, 700, -2, "135%"),
    "Content.Display02": buildVariant("Roboto, Noto Sans KR, sans-serif", 52, 700, -2, "135%"),
    "Content.Display03": buildVariant("Roboto, Noto Sans KR, sans-serif", 48, 700, -1, "135%"),
    "Content.Header01": buildVariant("Roboto, Noto Sans KR, sans-serif", 40, 700, -1, "135%"),
    "Content.Header02": buildVariant("Roboto, Noto Sans KR, sans-serif", 32, 700, -0.6, "135%"),
    "Content.Header03": buildVariant("Roboto, Noto Sans KR, sans-serif", 24, 700, -0.4, "135%"),
    "Content.Title01": buildVariant("Roboto, Noto Sans KR, sans-serif", 20, 700, -0.4, "135%"),
    "Content.Title02": buildVariant("Roboto, Noto Sans KR, sans-serif", 18, 700, -0.4, "135%"),
    "Content.Title03": buildVariant("Roboto, Noto Sans KR, sans-serif", 16, 700, -0.4, "135%"),
    "Content.Title04": buildVariant("Roboto, Noto Sans KR, sans-serif", 14, 700, -0.2, "140%"),
    "Content.Subtitle01": buildVariant("Roboto, Noto Sans KR, sans-serif", 18, 500, -0.4, "135%"),
    "Content.Subtitle02": buildVariant("Roboto, Noto Sans KR, sans-serif", 16, 500, -0.4, "135%"),
    "Content.Subtitle03": buildVariant("Roboto, Noto Sans KR, sans-serif", 14, 500, -0.2, "140%"),
    "Content.Subtitle04": buildVariant("Roboto, Noto Sans KR, sans-serif", 13, 500, -0.2, "135%"),
    "Content.Body01": buildVariant("Roboto, Noto Sans KR, sans-serif", 18, 400, -0.4, "135%"),
    "Content.Body02": buildVariant("Roboto, Noto Sans KR, sans-serif", 16, 400, -0.4, "135%"),
    "Content.Body03": buildVariant("Roboto, Noto Sans KR, sans-serif", 14, 400, -0.2, "140%"),
    "Content.Body04": buildVariant("Roboto, Noto Sans KR, sans-serif", 13, 400, -0.2, "135%"),
    "Content.Caption01": buildVariant("Roboto, Noto Sans KR, sans-serif", 12, 700, 0, "135%"),
    "Content.Caption02": buildVariant("Roboto, Noto Sans KR, sans-serif", 12, 500, 0, "135%"),
    "Content.Caption03": buildVariant("Roboto, Noto Sans KR, sans-serif", 10, 700, 0, "135%"),
    "Content.Caption04": buildVariant("Roboto, Noto Sans KR, sans-serif", 10, 500, 0, "135%"),
    "Content.EN.Display01": buildVariant("Roboto", 64, 700, -2, "135%"),
    "Content.EN.Display02": buildVariant("Roboto", 52, 700, -2, "135%"),
    "Content.EN.Display03": buildVariant("Roboto", 48, 700, -1, "135%"),
    "Content.EN.Header01": buildVariant("Roboto", 40, 700, -1, "135%"),
    "Content.EN.Header02": buildVariant("Roboto", 32, 700, -0.6, "135%"),
    "Content.EN.Header03": buildVariant("Roboto", 24, 700, -0.4, "135%"),
    "Content.EN.Title01": buildVariant("Roboto", 20, 700, -0.4, "135%"),
    "Content.EN.Title02": buildVariant("Roboto", 18, 700, -0.4, "135%"),
    "Content.EN.Title03": buildVariant("Roboto", 16, 700, -0.4, "135%"),
    "Content.EN.Title04": buildVariant("Roboto", 14, 700, -0.2, "140%"),
    "Content.EN.Subtitle01": buildVariant("Roboto", 18, 500, -0.4, "135%"),
    "Content.EN.Subtitle02": buildVariant("Roboto", 16, 500, -0.4, "135%"),
    "Content.EN.Subtitle03": buildVariant("Roboto", 14, 500, -0.2, "140%"),
    "Content.EN.Subtitle04": buildVariant("Roboto", 13, 500, -0.2, "135%"),
    "Content.EN.Body01": buildVariant("Roboto", 18, 400, -0.4, "135%"),
    "Content.EN.Body02": buildVariant("Roboto", 16, 400, -0.4, "135%"),
    "Content.EN.Body03": buildVariant("Roboto", 14, 400, -0.2, "140%"),
    "Content.EN.Body04": buildVariant("Roboto", 13, 400, -0.2, "135%"),
    "Content.EN.Caption01": buildVariant("Roboto", 12, 700, 0, "135%"),
    "Content.EN.Caption02": buildVariant("Roboto", 12, 500, 0, "135%"),
    "Content.EN.Caption03": buildVariant("Roboto", 10, 700, 0, "135%"),
    "Content.EN.Caption04": buildVariant("Roboto", 10, 500, 0, "135%"),
    "Content.KR.Display01": buildVariant("Noto Sans KR", 64, 700, -2, "135%"),
    "Content.KR.Display02": buildVariant("Noto Sans KR", 52, 700, -2, "135%"),
    "Content.KR.Display03": buildVariant("Noto Sans KR", 48, 700, -1, "135%"),
    "Content.KR.Header01": buildVariant("Noto Sans KR", 40, 700, -1, "135%"),
    "Content.KR.Header02": buildVariant("Noto Sans KR", 32, 700, -0.6, "135%"),
    "Content.KR.Header03": buildVariant("Noto Sans KR", 24, 700, -0.4, "135%"),
    "Content.KR.Title01": buildVariant("Noto Sans KR", 20, 700, -0.4, "135%"),
    "Content.KR.Title02": buildVariant("Noto Sans KR", 18, 700, -0.4, "135%"),
    "Content.KR.Title03": buildVariant("Noto Sans KR", 16, 700, -0.4, "135%"),
    "Content.KR.Title04": buildVariant("Noto Sans KR", 14, 700, -0.2, "140%"),
    "Content.KR.Subtitle01": buildVariant("Noto Sans KR", 18, 500, -0.4, "135%"),
    "Content.KR.Subtitle02": buildVariant("Noto Sans KR", 16, 500, -0.4, "135%"),
    "Content.KR.Subtitle03": buildVariant("Noto Sans KR", 14, 500, -0.2, "140%"),
    "Content.KR.Subtitle04": buildVariant("Noto Sans KR", 13, 500, -0.2, "135%"),
    "Content.KR.Body01": buildVariant("Noto Sans KR", 18, 400, -0.4, "135%"),
    "Content.KR.Body02": buildVariant("Noto Sans KR", 16, 400, -0.4, "135%"),
    "Content.KR.Body03": buildVariant("Noto Sans KR", 14, 400, -0.2, "140%"),
    "Content.KR.Body04": buildVariant("Noto Sans KR", 13, 400, -0.2, "135%"),
    "Content.KR.Caption01": buildVariant("Noto Sans KR", 12, 700, 0, "135%"),
    "Content.KR.Caption02": buildVariant("Noto Sans KR", 12, 500, 0, "135%"),
    "Content.KR.Caption03": buildVariant("Noto Sans KR", 10, 700, 0, "135%"),
    "Content.KR.Caption04": buildVariant("Noto Sans KR", 10, 500, 0, "135%"),
};
//# sourceMappingURL=typography.js.map